// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.MarketAnalyticsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  MarketAnalyticsWebApiHandler_getCompsForListing,
  MarketAnalyticsWebApiHandler_getCompsForListing_Path,
  MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings,
  MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_Path,
} from '@zg-rentals/ts-customer-analytics-client';

import type {
  ListingAlias,
  ListingCompsResponseDto,
  MonthlyPriceHistoryByListingAliasResponseDto,
} from '@zg-rentals/ts-customer-analytics-client';

interface GetCompsForListingParams {
  listingAlias?: ListingAlias;
  radius?: number;
  zrnNumber: string;
}

export type MarketAnalyticsWebApiHandler_getCompsForListing_Options = UseQueryOptions<
  ListingCompsResponseDto,
  unknown,
  ListingCompsResponseDto,
  readonly [string, GetCompsForListingParams]
>;

const MarketAnalyticsWebApiHandler_getCompsForListing_GetKey = (getParams: GetCompsForListingParams) =>
  [MarketAnalyticsWebApiHandler_getCompsForListing_Path, getParams] as const;

export const MarketAnalyticsWebApiHandler_getCompsForListing_queryOptions = (
  getParams: GetCompsForListingParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: MarketAnalyticsWebApiHandler_getCompsForListing_GetKey(getParams),
    queryFn: () => MarketAnalyticsWebApiHandler_getCompsForListing(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useMarketAnalyticsWebApiHandler_getCompsForListing = (
  getParams: GetCompsForListingParams,
  {
    httpClient,
    ...options
  }: Omit<MarketAnalyticsWebApiHandler_getCompsForListing_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...MarketAnalyticsWebApiHandler_getCompsForListing_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useMarketAnalyticsWebApiHandler_getCompsForListing.getKey = MarketAnalyticsWebApiHandler_getCompsForListing_GetKey;

export type MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_Options = UseQueryOptions<
  MonthlyPriceHistoryByListingAliasResponseDto,
  unknown,
  MonthlyPriceHistoryByListingAliasResponseDto,
  readonly [string, Array<ListingAlias>]
>;

const MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_GetKey = (postData: Array<ListingAlias>) =>
  [MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_Path, postData] as const;

export const MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_queryOptions = (
  postData: Array<ListingAlias>,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_GetKey(postData),
    queryFn: () => MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useMarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings = (
  postData: Array<ListingAlias>,
  {
    httpClient,
    ...options
  }: Omit<MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useMarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings.getKey =
  MarketAnalyticsWebApiHandler_getMonthlyPriceHistoryForListings_GetKey;
